if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}

// Re-initialize Afetto custom product gallery after King LinkedOption
// seamless product switching. The gallery's listeners are bound by an
// inline <script> on DOMContentLoaded in sections/main-product.liquid;
// since LO injects new section HTML via innerHTML, inline scripts don't
// execute and the new gallery is left without thumbnail/arrow handlers.
function __afettoInitGallery(gallery) {
  if (gallery.dataset.afettoGalleryBound === '1') return;
  gallery.dataset.afettoGalleryBound = '1';

  const track = gallery.querySelector('[data-main-track]');
  const slides = Array.from(gallery.querySelectorAll('[data-main-slide]'));
  const thumbs = Array.from(gallery.querySelectorAll('[data-thumb]'));
  const prev = gallery.querySelector('[data-gallery-prev]');
  const next = gallery.querySelector('[data-gallery-next]');
  let currentIndex = 0;

  if (!track || !slides.length || !thumbs.length) return;

  function setActive(index) {
    if (index < 0) index = slides.length - 1;
    if (index >= slides.length) index = 0;
    currentIndex = index;
    slides.forEach((s) => s.classList.remove('is-active'));
    thumbs.forEach((t) => t.classList.remove('is-active'));
    slides[currentIndex].classList.add('is-active');
    thumbs[currentIndex].classList.add('is-active');
    slides[currentIndex].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
    thumbs[currentIndex].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
  }

  thumbs.forEach((thumb, index) => {
    thumb.addEventListener('click', () => setActive(index));
  });
  if (prev) prev.addEventListener('click', () => setActive(currentIndex - 1));
  if (next) next.addEventListener('click', () => setActive(currentIndex + 1));

  track.addEventListener('scroll', () => {
    let closestIndex = 0;
    let closestDistance = Infinity;
    slides.forEach((slide, index) => {
      const distance = Math.abs(slide.getBoundingClientRect().left - track.getBoundingClientRect().left);
      if (distance < closestDistance) {
        closestDistance = distance;
        closestIndex = index;
      }
    });
    if (closestIndex !== currentIndex) {
      currentIndex = closestIndex;
      thumbs.forEach((t) => t.classList.remove('is-active'));
      if (thumbs[currentIndex]) thumbs[currentIndex].classList.add('is-active');
    }
  });
}

function __afettoRebindAllGalleries() {
  document.querySelectorAll('[data-afetto-gallery]').forEach(__afettoInitGallery);
}

['king-linked-options:product-seamless-switched',
 'king-linked-options:product-card-seamless-switched'].forEach((ev) => {
  document.addEventListener(ev, () => requestAnimationFrame(__afettoRebindAllGalleries));
});

// Persist variant option selection (e.g. "Tamanho") across LinkedOption
// seamless product switches. The app doesn't carry over the chosen
// option to the next product, so we read the user's selections before
// the swap (kept in sessionStorage on every change) and re-apply them
// on the new product picker if the same option value exists.
const __AFETTO_LO_STORAGE_KEY = 'afetto:lo:lastVariantOptions';

function __afettoReadCurrentOptions() {
  const map = {};
  document.querySelectorAll('variant-selects, variant-radios').forEach((picker) => {
    picker.querySelectorAll('fieldset').forEach((fs) => {
      const legend = fs.querySelector('legend');
      if (!legend) return;
      const name = legend.textContent.trim();
      const checked = fs.querySelector('input[type="radio"]:checked');
      const selected = fs.querySelector('select');
      if (checked) map[name] = checked.value;
      else if (selected) map[name] = selected.value;
    });
  });
  return map;
}

function __afettoSaveCurrentOptions() {
  try {
    sessionStorage.setItem(__AFETTO_LO_STORAGE_KEY, JSON.stringify(__afettoReadCurrentOptions()));
  } catch (_) {}
}

function __afettoRestoreOptions() {
  let saved;
  try { saved = JSON.parse(sessionStorage.getItem(__AFETTO_LO_STORAGE_KEY) || '{}'); } catch (_) { return; }
  if (!saved || !Object.keys(saved).length) return;

  document.querySelectorAll('variant-selects, variant-radios').forEach((picker) => {
    picker.querySelectorAll('fieldset').forEach((fs) => {
      const legend = fs.querySelector('legend');
      if (!legend) return;
      const name = legend.textContent.trim();
      const desired = saved[name];
      if (desired == null) return;

      const radio = fs.querySelector(`input[type="radio"][value="${CSS.escape(desired)}"]`);
      if (radio && !radio.disabled && !radio.checked) {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
        return;
      }
      const select = fs.querySelector('select');
      if (select) {
        const opt = Array.from(select.options).find((o) => o.value === desired);
        if (opt && !opt.disabled && select.value !== desired) {
          select.value = desired;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    });
  });
}

document.addEventListener('change', (e) => {
  if (e.target && e.target.closest && e.target.closest('variant-selects, variant-radios')) {
    __afettoSaveCurrentOptions();
  }
}, true);

document.addEventListener('DOMContentLoaded', __afettoSaveCurrentOptions);

['king-linked-options:product-seamless-switched',
 'king-linked-options:product-card-seamless-switched'].forEach((ev) => {
  document.addEventListener(ev, () => requestAnimationFrame(__afettoRestoreOptions));
});
